<div class="contact-information-container">
  <div class="section-header mb-2">
    <h4>Contact Information</h4>
    <p class="text-muted">Enter contact details for all parties involved in the transaction.</p>
  </div>

  <div class="contact-sections">
    <div class="contact-section mb-2">
      <seller-agent #sellerAgentSection
        [sellerRealEstateAgent]="sellerRealEstateAgent">
      </seller-agent>
    </div>

    <div class="contact-section mb-2">
      <title-information-step #titleInfoSection
        [titleInformation]="titleInformation">
      </title-information-step>
    </div>

    <div class="contact-section mb-2">
      <escrow-information #escrowInfoSection
        [escrowInformation]="escrowInformation">
      </escrow-information>
    </div>

    <div class="contact-section mb-2">
      <settlement-agent #settlementAgentSection
        [settlementInformation]="settlementInformation">
      </settlement-agent>
    </div>
  </div>
</div>
